import { getBridgeRoot } from '../../files/cwd/index.js';
import { installRemoteSkillsAsync } from '../../skills/install.js';
import { sendWsMessage } from '../../connection/create-ws-bridge.js';
import type { BridgeMessageHandler } from '../message-router.js';

export const handleInstallSkillsMessage: BridgeMessageHandler<'install_skills'> = (msg, deps) => {
  const id = typeof msg.id === 'string' ? msg.id : '';
  const targetDir =
    typeof msg.targetDir === 'string' && msg.targetDir.trim() ? msg.targetDir.trim() : '.agents/skills';
  const rawItems = msg.items;
  const cwd = getBridgeRoot();
  void (async () => {
    const socket = deps.getWs();
    const result = await installRemoteSkillsAsync(cwd, targetDir, rawItems as unknown[]);
    if (!result.success) {
      const err = result.error ?? 'Invalid items';
      deps.log(`[Bridge service] Install skills failed: ${err}`);
      if (socket) {
        sendWsMessage(socket, { type: 'install_skills_result', id, success: false, error: err });
      }
      return;
    }
    if (socket) {
      sendWsMessage(socket, { type: 'install_skills_result', id, success: true, installed: result.installed });
    }
  })();
};
